import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { SliderArrowButton } from "./style";

interface SliderArrowProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export function SliderPrevArrow({ className, style, onClick }: SliderArrowProps) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.();
    event.currentTarget.blur();
  };

  return (
    <SliderArrowButton
      type="button"
      className={className}
      style={style}
      onClick={handleClick}
      aria-label="Previous photo"
    >
      <ChevronLeft size={16} strokeWidth={2.5} />
    </SliderArrowButton>
  );
}

export function SliderNextArrow({ className, style, onClick }: SliderArrowProps) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onClick?.();
    event.currentTarget.blur();
  };

  return (
    <SliderArrowButton
      type="button"
      className={className}
      style={style}
      onClick={handleClick}
      aria-label="Next photo"
    >
      <ChevronRight size={16} strokeWidth={2.5} />
    </SliderArrowButton>
  );
}
